export function renderName(projectName) {
  const cleanedName = projectName?.replace(/[^\w\s]/g, "");
  const words = cleanedName?.trim()?.split(/\s+/);

  let initials = "";

  if (words?.length > 0) {
    initials += words[0][0]?.toUpperCase();

    if (words[0]?.length > 1) {
      initials += words[0][1]?.toUpperCase();
    }
  }

  return initials;
}
